import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {Store} from '@ngrx/store';
import {Observable} from 'rxjs';
import {map, pluck, shareReplay} from 'rxjs/operators';
import { AccountState } from 'store/account/account.state';
import {logout} from 'store/auth/auth.actions';
import {CompanyState} from 'store/company/company.state';
import { NotificationsState } from 'store/notifications/notifications.state';
import {CompanyDTO, HomepageService} from 'tekkeys-common';

@Component({
  selector: 'app-logout-drop-down-menu',
  templateUrl: './logout-drop-down-menu.component.html',
  styleUrls: ['./logout-drop-down-menu.component.scss'],
})
export class LogoutDropDownMenuComponent implements OnInit {
  accountNumber: Observable<string> = this.store
    .select('company')
    .pipe(map((state: CompanyState) => state.company?.accountNumber));
  username: Observable<string> = this.store
      .select('account')
      .pipe(
        map((state: AccountState) =>
          state.account ? state.account.name : 'Se connecter'
        ),
      );
    companyStore: Observable<CompanyDTO> = this.store
        .select('company')
        .pipe(shareReplay(2), pluck('company'));
      companyName: string;

  constructor(
    private router: Router,
    private store: Store<{
      account: AccountState;
      company: CompanyState;
      notifications: NotificationsState;
    }>,
    private homeService: HomepageService
  ) {
  }
  ngOnInit(): void {
          this.companyStore.subscribe((data) => {
        if (data) {
          this.companyName = data.name ? data.name : '';
        } else {
          this.companyName = '';
        }
      },
      () => {
        this.companyName = '';
      });
  }

  onLogOut() {
    this.store.dispatch(logout());
    this.router.navigate(['/']);
    if (JSON.parse(localStorage.getItem('history'))) {
      this.homeService
        .addCategoryVisitHistory(JSON.parse(localStorage.getItem('history')))
        .subscribe(() => {
            localStorage.removeItem('history');
          },
          () => {
            localStorage.removeItem('history');
          });
    }

    if (JSON.parse(localStorage.getItem('quotation'))) {
      localStorage.removeItem('quotation');
    }
  }
}
